<template>
  <div :class="$style.container">
    <h4 :class="$style.title">
      {{ title }}
    </h4>
    <div :class="$style.lang">
      <localization-controller
        :language="language"
        inverted-color
      />
    </div>
  </div>
</template>

<script>
import LocalizationController from 'organisms/localization/LocalizationController';

import { getLocaleCode } from '@/services/i18n-setup';
import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'AuthHeader',
  components: {
    LocalizationController,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  created() {
    EVENT_BUS.$on('change.localization', language => {
      this.language = language;
    });
  },
  data() {
    return {
      language: {
        code: getLocaleCode().toUpperCase(),
      },
    };
  },
};
</script>

<style lang="sass" module>
  .container
    display: flex
    align-items: center
    flex-grow: 1

  .title
    flex: 1
    font-weight: 600
    font-size: 16px
    line-height: 20px
    color: #fff

    +respond-to('small')
      font-size: 20px
      line-height: 24px

  .lang
    padding: 8px
    cursor: pointer
</style>
